import React, { FC } from 'react';

import {
  DrawerBottomSheet,
  DrawerBottomSheetContent,
  Modal,
  useLockBodyScroll,
} from '../..';
import { useToggleWithAnimation } from '../../hooks/useToggleWithAnimation';
import { useDrawer } from '../Drawer/useDrawer';
import { DEFAULT_SIZE } from '../Modal/constants';
import { useMediaQueries } from '../Provider/ResponsiveProvider';
import { SystemModalProps } from './types';

// TODO: review it. Animation transitions hooks should not be inside SystemModal
const ModalWrapper = ({ open, onClose, size, children, ...rest }) => {
  const fadeToggleProps = useToggleWithAnimation({
    isOpen: open,
  });
  const { state } = fadeToggleProps;

  useLockBodyScroll({ state });

  return (
    <Modal {...fadeToggleProps} onClose={onClose} size={size} {...rest}>
      {children}
    </Modal>
  );
};

const DrawerWrapper = ({ open, onClose, children, ...rest }) => {
  const { state, transitionDuration } = useDrawer({
    isOpen: open,
    transitionDuration: 300,
  });

  return (
    <DrawerBottomSheet
      state={state}
      transitionDuration={transitionDuration}
      onBackdropClick={onClose}
      {...rest}
    >
      <DrawerBottomSheetContent p="0">{children}</DrawerBottomSheetContent>
    </DrawerBottomSheet>
  );
};

const SystemModal: FC<SystemModalProps> = ({
  open,
  onClose,
  modalSize = DEFAULT_SIZE,
  children,
  ...rest
}) => {
  const { md } = useMediaQueries();

  if (!md) {
    return (
      <DrawerWrapper open={open} onClose={onClose} {...rest}>
        {children}
      </DrawerWrapper>
    );
  }

  return (
    <ModalWrapper open={open} onClose={onClose} size={modalSize} {...rest}>
      {children}
    </ModalWrapper>
  );
};

export default SystemModal;
